import * as React from 'react';
import {
    ShowBase,
    useShowContext,
    ReferenceManyField,
    TextField,
    Datagrid,
} from 'react-admin';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';

import { RoleAside } from './RoleAside';
import { Role } from '@/types';

export const RoleShow = () => (
    <ShowBase>
        <RoleShowContent />
    </ShowBase>
);

const RoleShowContent = () => {
    const { record, isPending } = useShowContext<Role>();
    if (isPending || !record) return null;

    return (
        <Box mt={2} mb={2} display="flex">
            <RoleAside />
            <Box flex="1">
                <Card>
                    <CardContent>
                        <Box display="flex">
                            <Box ml={2} flex="1" sx={{ mb: 2 }}>
                                <Typography variant="h5">
                                    {record.name}
                                </Typography>
                                <Divider sx={{my: 2}} />
                                <Typography variant="h4" mt={3}>
                                    Permissions
                                </Typography>

                                <ReferenceManyField
                                    label="Permissions"
                                    target="role_id"
                                    reference="permissions"
                                    sort={{ field: 'name', order: 'ASC' }}
                                    perPage={100}
                                >
                                    <Datagrid bulkActionButtons={false}>
                                        <TextField source="name" />
                                    </Datagrid>
                                </ReferenceManyField>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};
